import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appDocument]',
    standalone: false
})
export class DocumentDirective {
  regexStr = /[A-Z0-9]/;
  constructor() { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent): void {
    if (!new RegExp(this.regexStr).test(event.key)) {
      event.preventDefault();
    }
  }
}
